
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1401","fill":"none","stroke":"#000"}},[_c('g',{attrs:{"data-name":"사각형 1924","stroke-width":"2"}},[_c('rect',{attrs:{"width":"16","height":"20","rx":"2","stroke":"none"}}),_c('rect',{attrs:{"x":"1","y":"1","width":"14","height":"18","rx":"1"}})]),_c('path',{attrs:{"data-name":"선 474","stroke-linecap":"round","stroke-width":"2","d":"M4 4.5h8"}}),_c('path',{attrs:{"data-name":"선 475","stroke-linecap":"round","stroke-width":"2","d":"M4 8.5h8"}}),_c('path',{attrs:{"data-name":"패스 540","d":"M4.433 12.019l1.637-.583-1.178 4.122a7.544 7.544 0 012.615-.877c1 0 .808.877 1.369.877a19.415 19.415 0 002.553-.529","stroke-linecap":"round","stroke-linejoin":"round"}})])])
          )
        }
      }
    